<template>
  <div class="wk">
    <div><img src="@/assets/img/wk.png" /></div>
      <div style="margin-top:50px">腾讯微卡数据加载中···</div>
  </div>
</template>
<script>
import {wkLogin} from "../api/wkApi";
import {setLoginInfo} from "../utils";
import Vue from "vue";

export default {
  data() {
    return {
      wxcode: null,
      state: null
    }
  },
  mounted() {
    this.wxcode = this.$route.query.wxcode
    this.state = this.$route.query.state
    this.wkLogin()
  },
  methods: {
    wkLogin() {
      wkLogin({
        wkcode: this.wxcode,
        redirectUrl: process.env.WK_REDIRECT_URI
      }).then(res => {
        if (res && res.code === 0) {
          setLoginInfo(res.data)
          this.$router.push({path: '/home'})
        } else {
          this.$message.error(res.msg)
        }
      })
    },
  }
}
</script>
<style scoped>
.wk{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/views/wkLogin.vue